import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { SocieteDacListItem } from '@/types';
import { PaymentJustificationRepository } from '@/store/payment-justification-state/payment-justification-state.repository';

interface PaymentJustificationDataTableProps {
  store: PaymentJustificationRepository;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
  enableServerActions?: boolean;
  openDrawerArgs: (row: SocieteDacListItem) => void;
}

export const getPaymentJustificationDataTableStructure = ({
  store,
  rowActions,
  serverQuery,
  enableServerActions,
}: PaymentJustificationDataTableProps): DynamicDataTable => {
  const nomSocieteCol: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.paymentJustification.table.companyName',
    accessorKey: 'societe.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const categorieCol: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.paymentJustification.table.category',
    accessorKey: 'societe.categorieSoumissionnaire.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const methodePaiementCol: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.paymentJustification.table.paymentMethod',
    accessorKey: 'methodePaiement',
    variant: DataTableColumnVariant.TEXT,
  };

  const dacReferenceCol: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.paymentJustification.table.dacReference',
    accessorKey: 'dacReference',
    variant: DataTableColumnVariant.TEXT,
  };

  const dateLimiteSoumissionCol: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.paymentJustification.table.dateLimiteSoumission',
    accessorKey: 'dateLimiteSoumission',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'settings.paymentJustification.table.singular',
    plural: 'settings.paymentJustification.table.plural',
    columns: [nomSocieteCol, categorieCol, methodePaiementCol, dacReferenceCol, dateLimiteSoumissionCol],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: SocieteDacListItem) => {
      store.set('response', row);
      store.set('dto', row);
    },
    rowActions,
    serverQuery,
    enableServerActions,
    // Add searchable fields if backend supports it. Usually names.
    searchableFields: ['societe.nom'],
  };
};
